import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "user",
  initialState: {},
  reducers: {
    USER_DETAILS: (user, action) => {
        return { ...user, ...action.payload };
    },
  },
});

export const { USER_DETAILS } = slice.actions;

export default slice.reducer;
